module.exports = __webpack_public_path__ + "img/learn-3.5564a461.png";